import type { EventDataLayout } from "@moment-golf/types";

export const eventDataLayout = [
    {
        section: "Event Details",
        field: "totalRounds",
        label: "Total Rounds",
        required: true,
        block: 0,
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "totalHoles",
        label: "Total Holes",
        required: true,
        block: 0,
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "eventType",
        label: "Event Type",
        required: true,
        block: 0,
        labelField: "type",
        optionsKeyName: "EventType",
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "playType",
        label: "Play Type",
        required: true,
        block: 0,
        labelField: "type",
        optionsKeyName: "PlayTypes",
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "playFormat",
        label: "Play Format",
        required: true,
        block: 0,
        labelField: "type",
        optionsKeyName: "PlayFormats",
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "defaultTeeOrder",
        label: "Default Tee Order",
        required: true,
        block: 0,
        labelField: "type",
        optionsKeyName: "TeeOrder",
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "secondaryTeeOrder",
        label: "Post Cut Tee Order",
        required: true,
        block: 0,
        labelField: "type",
        optionsKeyName: "TeeOrder",
        blockName: "The Event",
        removable: true,
    },
    {
        section: "Event Details",
        field: "roundLengthTarget",
        label: "Round Length Target",
        required: true,
        block: 0,
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "eventRegion",
        label: "Event Region",
        required: true,
        block: 0,
        blockName: "The Event",
        removable: true,
    },
    {
        section: "Event Details",
        field: "eventState",
        label: "Event State",
        required: true,
        block: 0,
        blockName: "The Event",
        removable: true,
    },
    {
        section: "Event Details",
        field: "tags",
        label: "Tags",
        required: true,
        block: 0,
        blockName: "The Event",
    },
    {
        section: "Event Details",
        field: "playerCap",
        label: "Player Cap",
        required: true,
        block: 1,
        blockName: "The Field",
    },
    {
        section: "Event Details",
        field: "waitList",
        label: "Wait List",
        required: true,
        block: 1,
        blockName: "The Field",
    },
    {
        section: "Event Details",
        field: "cutAfterRound",
        label: "Cut After Round",
        required: true,
        block: 1,
        blockName: "The Field",
    },
    {
        section: "Event Details",
        field: "cutPlayerCap",
        label: "Cut Player Cap",
        required: true,
        block: 1,
        blockName: "The Field",
        removable: true,
    },
    {
        section: "Event Details",
        field: "cutScoreCap",
        label: "Cut Score Cap",
        required: true,
        block: 1,
        blockName: "The Field",
        removable: true,
    },
    {
        section: "Event Details",
        field: "cutIncludeTies",
        label: "+ Ties",
        required: true,
        block: 1,
        blockName: "The Field",
        defaultValue: true,
    },
    {
        section: "Event Details",
        field: "regOpenDate",
        label: "Signup Open Date",
        required: false,
        block: 2,
        blockName: "Registration",
        removable: true,
    },
    {
        section: "Event Details",
        field: "regCloseDate",
        label: "Signup Close Date",
        required: true,
        block: 2,
        blockName: "Registration",
        removable: true,
    },
    {
        section: "Event Details",
        field: "regType",
        label: "Registration Type",
        required: true,
        block: 2,
        labelField: "type",
        optionsKeyName: "RegTypes",
        blockName: "Registration",
    },
    {
        section: "Event Details",
        field: "regQty",
        label: "Registration Qty",
        required: true,
        block: 2,
        blockName: "Registration",
    },
    {
        section: "Event Details",
        field: "regPerTeeTime",
        label: "Qty Per Tee Time",
        required: true,
        block: 2,
        blockName: "Registration",
    },
    {
        section: "Event Details",
        field: "useTeams",
        label: "Teams",
        required: true,
        block: 2,
        blockName: "Registration",
    },
    {
        section: "Event Details",
        field: "teamSize",
        label: "Team Size",
        required: true,
        block: 2,
        blockName: "Registration",
        removable: true,
    },
    {
        section: "Event Details",
        field: "countingScores",
        label: "Counting Scores",
        required: true,
        block: 2,
        blockName: "Registration",
        removable: true,
    },
    {
        section: "Event Details",
        field: "useRivalry",
        label: "Rivalry",
        required: true,
        block: 2,
        blockName: "Registration",
    },
    {
        section: "Event Details",
        field: "maxHoleScore",
        label: "Max Hole Score",
        required: true,
        block: 3,
        labelField: "type",
        optionsKeyName: "MaxHoleScore",
        blockName: "Scoring Methods",
        removable: true,
    },
    {
        section: "Event Details",
        field: "scoreMedium",
        label: "Score Medium",
        required: true,
        block: 3,
        labelField: "type",
        optionsKeyName: "ScoreMedium",
        blockName: "Scoring Methods",
    },
    {
        section: "Event Details",
        field: "scoreType",
        label: "Score Type",
        required: true,
        block: 3,
        labelField: "type",
        optionsKeyName: "ScoreType",
        blockName: "Scoring Methods",
    },
    {
        section: "Event Details",
        field: "scoreFormat",
        label: "Score Format",
        required: true,
        block: 3,
        labelField: "type",
        optionsKeyName: "ScoreFormat",
        blockName: "Scoring Methods",
    },
    {
        section: "Event Details",
        field: "scoreVerification",
        label: "Score Verification",
        required: true,
        block: 3,
        labelField: "type",
        optionsKeyName: "ScoreVerification",
        blockName: "Scoring Methods",
    },
    {
        section: "Event Details",
        field: "reqDigital",
        label: "Require Digital Scorecard",
        required: true,
        block: 3,
        blockName: "Scoring Methods",
    },
    {
        section: "Event Details",
        field: "submissionCode",
        label: "Submission Code",
        required: true,
        block: 3,
        blockName: "Scoring Methods",
        removable: true,
    },
    {
        section: "Event Details",
        field: "type",
        label: "Type",
        required: true,
        block: 4,
        blockName: "Handicap Usage",
        removable: true,
    },
    {
        section: "Event Details",
        field: "indReduction",
        label: "Reduction %",
        required: true,
        block: 4,
        blockName: "Handicap Usage",
        removable: true,
    },
    {
        section: "Event Details",
        field: "compositeType",
        label: "Method",
        required: true,
        block: 4,
        blockName: "Handicap Usage",
        removable: true,
    },
    {
        section: "Event Details",
        field: "compositeBuild",
        label: "Composite",
        required: true,
        block: 4,
        blockName: "Handicap Usage",
        removable: true,
    },
    {
        section: "Event Details",
        field: "eventCode",
        label: "Event Code",
        required: true,
        block: 5,
        blockName: "Access",
        removable: true,
    },
    {
        section: "Event Details",
        field: "eventLink",
        label: "Event Link",
        required: true,
        block: 5,
        blockName: "Access",
        removable: true,
    },
    {
        section: "Event Details",
        field: "privacyGroup",
        label: "Privacy Group",
        required: true,
        block: 5,
        labelField: "group",
        optionsKeyName: "PrivacyGroup",
        blockName: "Access",
        removable: true,
    },
    {
        section: "Event Details",
        field: "privacyRegType",
        label: "Registration Privacy",
        required: true,
        block: 5,
        labelField: "group",
        optionsKeyName: "PrivacyRegType",
        blockName: "Access",
        removable: true,
    },
    {
        section: "Event Details",
        field: "privacyViewType",
        label: "Viewing Privacy",
        required: true,
        block: 5,
        labelField: "group",
        optionsKeyName: "PrivacyViewType",
        blockName: "Access",
        removable: true,
    },
    {
        section: "Event Details",
        field: "privacyAccessType",
        label: "Event Access Method",
        required: true,
        block: 5,
        labelField: "group",
        optionsKeyName: "PrivacyAccessType",
        blockName: "Access",
        removable: true,
    },
    {
        section: "Event Details",
        field: "published",
        label: "Published",
        required: true,
        block: 5,
        blockName: "Access",
    },
    {
        section: "Event Details",
        field: "eventFee",
        label: "Event Fee per Reg",
        required: true,
        block: 6,
        blockName: "Event Fees",
        defaultValue: 0,
    },
    {
        section: "Event Details",
        field: "flightPricing",
        label: "Price by Flight",
        required: true,
        block: 6,
        blockName: "Event Fees",
        defaultValue: false,
    },
    {
        section: "Event Details",
        field: "earlyRegDiscount",
        label: "Early Reg Discount",
        required: true,
        block: 6,
        blockName: "Event Fees",
        removable: true,
    },
    {
        section: "Event Details",
        field: "earlyRegCutoffDate",
        label: "Early Reg Cutoff Date",
        required: true,
        block: 6,
        blockName: "Event Fees",
        defaultValue: "",
        removable: true,
    },
    {
        section: "Event Details",
        field: "regCutoffDate",
        label: "Reg Cutoff Date",
        required: true,
        block: 6,
        blockName: "Event Fees",
        defaultValue: "",
        removable: true,
    },
    {
        section: "Event Details",
        field: "canceled",
        label: "Canceled",
        required: true,
        block: 7,
        blockName: "Management",
        locked: true,
    },
    {
        section: "Event Details",
        field: "canceledBy",
        label: "Canceled By",
        required: true,
        block: 7,
        blockName: "Management",
        locked: true,
    },
    {
        section: "Event Details",
        field: "canceledAt",
        label: "Canceled At",
        required: true,
        block: 7,
        blockName: "Management",
        locked: true,
    },
    {
        section: "Event Details",
        field: "createdAt",
        label: "Created At",
        required: true,
        block: 7,
        blockName: "Management",
        locked: true,
    },
    {
        section: "Event Details",
        field: "createdBy",
        label: "Created By",
        required: true,
        block: 7,
        blockName: "Management",
        locked: true,
    },
    {
        section: "Event Details",
        field: "modifiedAt",
        label: "Modified At",
        required: true,
        block: 7,
        blockName: "Management",
        locked: true,
    },
    {
        section: "Event Details",
        field: "modifiedBy",
        label: "Modified By",
        required: true,
        block: 7,
        blockName: "Management",
        locked: true,
    },
    {
        section: "Info",
        field: "eventInfo",
        label: "Event Info",
        required: true,
    },
] satisfies EventDataLayout;
